/**
 * Horizontal scroll controls for deals page carousels and quick-link rows.
 */
(function () {
  function initScrollRow(row) {
    const track = row.querySelector('[data-deals-scroll-track]');
    const prev = row.querySelector('[data-deals-scroll-prev]');
    const next = row.querySelector('[data-deals-scroll-next]');
    if (!track) return;

    const scrollAmount = () => Math.max(track.clientWidth * 0.75, 220);

    if (prev) {
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-deals-scroll-row]').forEach(initScrollRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
